export default __webpack_public_path__ + "static/media/RssSimple_3.bd19a888.svg";